import { render, staticRenderFns } from "./OrmBatchingViewSideMenu.vue?vue&type=template&id=34ec691b"
import script from "./OrmBatchingViewSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmBatchingViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports